import { Price } from "~/core/Price";

export class OfferPrices {
  readonly totalPrice: Price;
  readonly totalPriceToPay: Price;
  readonly pricePerNight: Price;
  readonly cityTax: Price;

  constructor(
    totalPrice: Price,
    totalPriceToPay: Price,
    pricePerNight: Price,
    cityTax: Price,
  ) {
    this.totalPrice = totalPrice;
    this.totalPriceToPay = totalPriceToPay;
    this.pricePerNight = pricePerNight;
    this.cityTax = cityTax;

    Object.freeze(this);
  }
}
